export default "__VITE_ASSET__CLlA0diO__"